import React from 'react';
import { ProviderValue } from '.';

export const FirebaseContext = React.createContext<ProviderValue>({});
